// extracted by mini-css-extract-plugin
module.exports =  {"container":"Wq02RgDb","content":"PVYDGGhf","body":"QsJl4FKu","sidebar":"kVm34HXg","feedbackDiscoveryLabel":"ZS6Ygp4p","usageContainer":"eIiVUxef"};